import React from 'react';
import EditExpenseComponent from '../../../Components/Expense/EditExpense';

export default function EditExpense() {
    return (
        <div className='page-body'>
            <EditExpenseComponent />
        </div>
    );
}